// Import model
import { OtgLaminatesCatalogStyleCondition } from '../models/OtgLaminatesCatalogStyleCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { OtgLaminatesCatalogStyleIndexedFields } from '../models/OtgLaminatesCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { OtgLaminatesCatalogStyleIndexedFieldsSerializer } from './OtgLaminatesCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgLaminatesCatalogStyleCondition - handles JSON serialization and deserialization with type validation
 */
export class OtgLaminatesCatalogStyleConditionSerializer {
  /**
   * Deserializes a JSON string into a OtgLaminatesCatalogStyleCondition instance
   */
  static deserialize(json: string): OtgLaminatesCatalogStyleCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgLaminatesCatalogStyleCondition instance
   */
  static fromObject(obj: any): OtgLaminatesCatalogStyleCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgLaminatesCatalogStyleCondition');
    }


    const instance: OtgLaminatesCatalogStyleCondition = {
      fieldName: obj['fieldName'] as OtgLaminatesCatalogStyleIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgLaminatesCatalogStyleCondition instances
   */
  static deserializeArray(json: string): OtgLaminatesCatalogStyleCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgLaminatesCatalogStyleCondition instance to a JSON string
   */
  static serialize(instance: OtgLaminatesCatalogStyleCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgLaminatesCatalogStyleCondition instance to a plain object
   */
  static toObject(instance: OtgLaminatesCatalogStyleCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of OtgLaminatesCatalogStyleCondition instances to a JSON string
   */
  static serializeArray(instances: OtgLaminatesCatalogStyleCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
